const id_common_report = {
    sales_commission: {
        "": "komisi sales",
        total: 'total komisi sales',
        label: {
            total: "total komisi"
        }
    },

    return_cus: {
        "": 'retur penjualan',
        total: 'total nominal retur penjualan',
    },
    return_sup: {
        "": 'retur pembelian',
        total: 'total nominal retur pembelian',
    },
}

export default id_common_report;